// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file reports/customer_profitability_report.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { CustomerProfitabilityItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.CustomerProfitabilityReportRequest
 */
export class CustomerProfitabilityReportRequest extends Message<CustomerProfitabilityReportRequest> {
  /**
   * Page number for pagination
   *
   * @generated from field: int32 page_number = 1;
   */
  pageNumber = 0;

  /**
   * Number of records per page
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize = 0;

  constructor(data?: PartialMessage<CustomerProfitabilityReportRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CustomerProfitabilityReportRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CustomerProfitabilityReportRequest {
    return new CustomerProfitabilityReportRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CustomerProfitabilityReportRequest {
    return new CustomerProfitabilityReportRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CustomerProfitabilityReportRequest {
    return new CustomerProfitabilityReportRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CustomerProfitabilityReportRequest | PlainMessage<CustomerProfitabilityReportRequest> | undefined, b: CustomerProfitabilityReportRequest | PlainMessage<CustomerProfitabilityReportRequest> | undefined): boolean {
    return proto3.util.equals(CustomerProfitabilityReportRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.CustomerProfitabilityReportResponse
 */
export class CustomerProfitabilityReportResponse extends Message<CustomerProfitabilityReportResponse> {
  /**
   * List of customer profitability items
   *
   * @generated from field: repeated com.neulink.pharmacy.CustomerProfitabilityItem customer_profitability_items = 1;
   */
  customerProfitabilityItems: CustomerProfitabilityItem[] = [];

  /**
   * Total number of items available
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<CustomerProfitabilityReportResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CustomerProfitabilityReportResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "customer_profitability_items", kind: "message", T: CustomerProfitabilityItem, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CustomerProfitabilityReportResponse {
    return new CustomerProfitabilityReportResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CustomerProfitabilityReportResponse {
    return new CustomerProfitabilityReportResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CustomerProfitabilityReportResponse {
    return new CustomerProfitabilityReportResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CustomerProfitabilityReportResponse | PlainMessage<CustomerProfitabilityReportResponse> | undefined, b: CustomerProfitabilityReportResponse | PlainMessage<CustomerProfitabilityReportResponse> | undefined): boolean {
    return proto3.util.equals(CustomerProfitabilityReportResponse, a, b);
  }
}

